import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: 'Membros',
  loadError: 'Não foi possível carregar os membros',
  retry: 'Tentar de novo',
  invite: 'Convidar membro',
  inviteAfterApproval: 'Os convites para a equipe abrem depois da aprovação da conta.',
  ownerOnly: 'Só o responsável pela conta convida e remove membros.',
  invitePending: 'Convite de {{role}} · vale até {{date}}',
  remove: 'Remover',
  removeLabel: 'Remover {{name}}',
  revoke: 'Retirar convite',
  revokeLabel: 'Retirar o convite de {{email}}',
  removeTitle: 'Remover da equipe',
  removeMessage: '{{name}} perde o acesso ao portal na hora. Dá para convidar de novo depois.',
  removeConfirm: 'Remover',
  revokeTitle: 'Retirar convite',
  revokeMessage: 'O link enviado para {{email}} deixa de funcionar.',
  revokeConfirm: 'Retirar',
  cancel: 'Cancelar',
  removed: 'Membro removido',
  revoked: 'Convite retirado',
} satisfies TranslationTree;
